import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Button
} from "reactstrap";

import { toggleSidebar } from "../../system/store/site/actions";
import logo from "../../assets/images/viva.png";

const SideBarHeader = props => {
  return (
    <div className="sidebar-header">
      <UncontrolledDropdown>
        <DropdownToggle color="white">
          Weekender Breaks USA
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>Your Account</DropdownItem>
          <Link to={"/users/edit/" + props.currentUser.id}>
            <DropdownItem>Profile</DropdownItem>
          </Link>
          <DropdownItem divider />
          <DropdownItem onClick={props.logout}>Logout</DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
      <Button
        className="ml-auto close-menu"
        outline
        onClick={() => props.dispatch(toggleSidebar(false))}
      >
        Close
      </Button>
    </div>
  );
};

export default connect()(SideBarHeader);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Header.jsx